<template>
    <div class="flex items-center">
    <feather-icon
      v-if="value"
        icon="CalendarIcon"
        svgClasses="h-5 w-5 mr-1" />
    <span>
        {{ value | date_format(
        'DD MMM YYYY HH:mm A',
        true,
        this.tenantAccountDetailsTimezone,
        true,
        ) }}
    </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WaitingListCellRendererActions',
  props: {
    isAgGridComponent: {
      type: Boolean,
      default: true,
    },
    createdAt: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      tenantAccountDetailsTimezone: 'auth/tenantAccountDetailsTimezone',
    }),
    value() {
      if (this.createdAt) return this.createdAt;

      return (this.params && this.params.value ? this.params.value : null);
    },
  },
};
</script>
